// snackbar for success and failure massages 
import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import {toggleSnackbar} from "../../ReactiveVariables/index";
import { useReactiveVar } from '@apollo/client';

const CustomizedSnackbars = (props) => {
  const toggleSnackbarVar=useReactiveVar(toggleSnackbar)
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    toggleSnackbar({...toggleSnackbarVar,status:false})
  };

  return (
    <Snackbar open={toggleSnackbarVar.status} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{"vertical":"top","horizontal": "right"}}>
      <MuiAlert onClose={handleClose} severity={toggleSnackbarVar.variant || 'success'} elevation={6} variant="filled">
        {toggleSnackbarVar.message}
      </MuiAlert>
    </Snackbar>
  );
};

export default CustomizedSnackbars;